<script lang="ts">
  import { page } from '$app/state';
  import { afterNavigate, goto } from '$app/navigation';

  import { URLSearchParamsKey } from '$provider/constants/URLSearchParamsKey';
  interface Props {
    children?: import('svelte').Snippet;
  }

  let { children }: Props = $props();

  afterNavigate(() => {
    onRouteChange();
  });

  const onRouteChange = () => {
    const targetId = page.url.searchParams.get(URLSearchParamsKey.ScrollTarget);
    if (!targetId) return;

    contentScrollIntoView(targetId);
    goto(page.url.pathname, { replaceState: true });
  };

  const contentScrollIntoView = (targetId: string): void => {
    const ele = document.getElementById(targetId);
    if (!ele) return;
    ele.scrollIntoView({ behavior: 'smooth' });
  };
</script>

<div class="comp-scrollable-view">
  {@render children?.()}
</div>
